import { useTranslation } from 'react-i18next';
import filesaver from 'filesaver.js';
import { useAllLabels } from 'entities/label';

interface Label {
  id: number;
  key: string;
  text: string;
  locale: string;
  visibility: string;
}

interface DownloadFileOptions {
  content?: string;
  fileName?: string;
  fileEncoding?: string;
  fileType?: string;
}

const downloadFile = ({ content = '', fileName = 'file.txt', fileEncoding = 'utf-8', fileType = 'text/csv;charset=utf-8;' }: DownloadFileOptions) => {
  const LegacyTextEncoder = TextEncoder as unknown as new (encoding: string, options: { NONSTANDARD_allowLegacyEncoding: boolean }) => TextEncoder;
  const encodedContent = new LegacyTextEncoder(fileEncoding, { NONSTANDARD_allowLegacyEncoding: true }).encode(content);
  const blob = new Blob([encodedContent], { fileType } as BlobPropertyBag);
  filesaver.saveAs(blob, fileName);
};

const exportLabels = (labels: Label[]) => {
  return {
    labels: labels.map((l) => ({
      id: l.id,
      key: l.key,
      text: l.text,
      locale: l.locale,
      visibility: l.visibility,
    })),
  };
};

function LabelDownloadButton() {
  const { t } = useTranslation('labels');

  const date = new Date();
  const fileName = `labels_${date.getFullYear()}_${date.getMonth() + 1}_${date.getDay() + 1}.json`;

  const { data, isLoading } = useAllLabels();

  const handleDownload = () => {
    downloadFile({
      content: JSON.stringify(exportLabels(data as Label[])),
      fileName,
    });
  };

  return (
    <button className="btn btn-secondary me-2" onClick={handleDownload} disabled={isLoading}>
      <i className="fa fa-download" /> {t('download.button')}
    </button>
  );
}

export default LabelDownloadButton;
